"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatExpiryDate;
function formatExpiryDate() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var previousValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var onlyNums = value.replace(/[^0-9]/g, '');
  if (!onlyNums) {
    return onlyNums;
  }

  // [MM/YYX => MM/YY]
  if (onlyNums.length > 4) {
    var onlyNumsStrip = onlyNums.substr(0, 4);
    return onlyNumsStrip.replace(/(.{2})/, '$1/');
  }
  var prevSlashIndex = previousValue.indexOf('/');
  var slashIndex = value.indexOf('/');

  // deleting
  if (previousValue.length > value.length) {
    // console.warn('deleting');

    // attempt to delete slash
    if (slashIndex < 0) {
      // allow delete if at end [MM/ => MM] [M/ => M] [/ =>  ]
      if (prevSlashIndex === onlyNums.length) {
        return onlyNums;
      }
      // [M/YY => M/YY] [M/Y => M/Y]
      if (prevSlashIndex === 1) {
        return onlyNums.replace(/(.{1})/, '$1/');
      }
      // [MM/YY => MM/YY] [MM/Y => MM/Y] [/YY => MM/]
      // do not allow delete ('switch slash to end');
      return onlyNums.replace(/(.{2})/, '$1/');
    }

    // delete after slash
    // [/YY => /Y]
    /* if (slashIndex === 0) {
      return value.replace(/[^/0-9]/g, '');
    }
    // [M/YY => M/Y]
    if (slashIndex === 1 && onlyNums.length === 2) {
      return onlyNums.replace(/(.{1})/, '$1/');
    } */

    // ensure numbers and slashes only
    return value.replace(/[^/0-9]/g, '');
  }

  // adding
  // typing after slash
  if (slashIndex === 1) {
    // [M/YY => MM/YY]
    if (onlyNums.length === 3) {
      return onlyNums.replace(/(^)(.{1})/, '0$2/');
    }

    // [M/ => M/Y] [M/Y => M/YY]
    if (onlyNums.length <= 3) {
      return onlyNums.replace(/(.{1})/, '$1/');
    }

    // // [M/YYY => M/YY]
    // if (onlyNums.length >= 4) {
    //   return previousValue.replace(/[^/0-9]/g, '');
    // }
  }

  // [MM => MM/] [MM/ => MM/Y] [MM/Y => MM/YY]
  return onlyNums.replace(/(.{2})/, '$1/');
}